import { Helmet } from 'react-helmet';
import { useEffect } from 'react';

function MC() {
    // full-bleed iframe with its own background - suppress the global grain
    // wallpaper so it can't bleed behind it (same as the home page)
    useEffect(() => {
        document.body.classList.add('home-page');
        return () => document.body.classList.remove('home-page');
    }, []);

    return (
        <>
            <Helmet>
                <title>ojee / Minecraft Server</title>
                <meta name="description" content="Private modded Minecraft server - live status, player list, and world switching." />
                <link rel="canonical" href="https://ojee.net/mc" />
            </Helmet>
            <iframe
                title="ojee.net minecraft"
                src="/redesign-demos/mc/index.html?v=6"
                style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', border: 0, background: '#06060a', zIndex: 1 }}
            />
        </>
    );
}

export default MC;
